import { Dispatch } from "react";
import moment from "moment";
import { OrderCustom } from "../../services/order.service";
import { Setting } from "../../services/user.service";
import { useDispatch } from "react-redux";
import { onUpdateCustomOrderStatus } from "../../slices/thunk";
import Modal from "../../Common/Components/Modal";
import { OrderStatusHelper } from "../../Common/Components/Status";
import { getFirstFilesPath } from "../../helpers/file_helper";
import { Link } from "react-router-dom";
import { currencyFormatter } from "../../helpers/formatter";

type OrderProductModalProps = {
  isOpen: boolean
  setIsOpen: Dispatch<boolean>
  order: OrderCustom | undefined
  setOrder: Dispatch<OrderCustom>
  orderStatusList: Setting[]
}

const CustomOrderProductModal = (
  { isOpen, setIsOpen, order, setOrder, orderStatusList }: OrderProductModalProps
) => {
  const dispatch = useDispatch<any>();

  const currentStatus = orderStatusList.find((status) => status.code === order?.status)
  const nextStatusButtons = orderStatusList.filter((status) => status.level === (currentStatus?.level || 0) + 1)

  const handleUpdateOrderStatus = (status: string) => {
    if (order?.orderCustomId) {
      dispatch(onUpdateCustomOrderStatus({ orderCustomId: order.orderCustomId, status })).then((response: any) => {
        setOrder(response.payload)
      })
    }
  }

  return (
    <Modal show={!!isOpen} onHide={() => setIsOpen(false)} modal-center="true"
      className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
      dialogClassName="w-screen md:w-[70rem] bg-white shadow rounded-md dark:bg-zink-600">
      <Modal.Header className="flex items-center justify-between p-4 border-b dark:border-zink-500"
        closeButtonClass="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500">
        <Modal.Title className="text-16">{'Order Details'}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          <div className="xl:col-span-6">
            <label htmlFor="orderDateInput" className="inline-block mb-2 text-base font-medium">Order Date: {moment(order?.createdAt).format('DD MMM yyyy')}</label>
          </div>
          <div className="xl:col-span-6">
            <label htmlFor="deliveryDateInput" className="inline-block mb-2 text-base font-medium">Delivery Date: {order?.deliveryDate ? moment(order?.deliveryDate).format('DD MMM yyyy') : '-'}</label>
          </div>
          <div className="xl:col-span-6">
            <label htmlFor="deliveryDateInput" className="inline-block mb-2 text-base font-medium">Delivery Method: {order?.deliveryMethod}</label>
          </div>
          {
            order?.deliveryMethod === 'delivery' &&
            <div className="xl:col-span-6">
              <label htmlFor="deliveryDateInput" className="inline-block mb-2 text-base font-medium">Delivery Address: {order?.deliveryAddress}</label>
            </div>
          }
          <div className="xl:col-span-12">
            <label htmlFor="customerNameInput" className="inline-block mb-2 text-base font-medium">Customer Name: {order?.customer?.name}</label>
          </div>
          <div className="xl:col-span-12">
            <label htmlFor="amountInput" className="inline-block mb-2 text-base font-medium">Amount: {currencyFormatter(order?.subtotal || 0)}</label>
          </div>
          <div className="xl:col-span-12">
            <label htmlFor="deliveryStatusSelect" className="inline-block mb-2 text-base font-medium mr-2">Status:</label>
            <OrderStatusHelper status={order?.status || ''} list={orderStatusList} />
          </div>
          <div className="xl:col-span-12">
            <label htmlFor="deliveryStatusSelect" className="inline-block mb-2 text-base font-medium mr-2">Image:</label>
            <img src={getFirstFilesPath(order?.files || [])} alt="" />
          </div>
          <div className="xl:col-span-12">
            <label htmlFor="deliveryStatusSelect" className="inline-block mb-2 text-base font-medium mr-2">Description: {order?.description}</label>
          </div>
          <div className="xl:col-span-12">
            <div className="ltr:lg:text-right rtl:lg:text-left">
              {
                !currentStatus?.isFinal && nextStatusButtons?.map((status: Setting, index: number) => {
                  return (
                    <Link to="#!" data-modal-target="addOrderModal" type="button" key={index}
                      className="ml-4 text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                      onClick={() => handleUpdateOrderStatus(status.code)}
                    >
                      <span className="align-middle">{status.value}</span>
                    </Link>
                  )
                })
              }
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default CustomOrderProductModal;